import { useQuery, type UseQueryResult } from '@tanstack/react-query'

import { type PartnerEntity } from '@/libs/api'

import { getPartnersSelectQueryOptions } from '../query-options'

/**
 * Select用のパートナー一覧のUseQuery
 */
export const usePartnersSelectQuery = (
  tenantKey: string,
  options?: {
    disabled?: boolean
    dcId?: number
  }
): UseQueryResult<PartnerEntity[]> => {
  const disabled = options?.disabled ?? false
  const dcId = options?.dcId
  return useQuery<PartnerEntity[]>({
    ...getPartnersSelectQueryOptions(tenantKey, dcId),
    enabled: !disabled,
    retry: false
  })
}
